<template>
  <div>
    <h1 class="mdn-Heading mdn-Heading--sm">Tipos de Serviços</h1>
    <div class="mb-2 mt-3 d-flex" style="gap: 12px">
      <SGPFormSelectComponent 
        :name="'exibirItensDeletados'" :listaDeOptions="opcoesSelect"
        v-model="exibirItensDeletados" :optionLabel="'nome'" :placeholder="'Visualizar Itens Deletados'"
        :error="validationErrors.first('exibirItensDeletados')" data-vv-as="Visualizar Itens Deletados"
        :optionSelecione="'Não'" @change="filtrarDeletados($event)"
      />
    </div>
    <SGPBotaoAdicionarNovoComponent @sgpAdiconarNovoEmit="adicionarNovo" />

      <SGPTabelaAvancadaComponent
        v-if="listaDeTiposServico && listaDeTiposServico.length"
        :colunas="colunas"
        :dados="listaDeTiposServico"
        :key="JSON.stringify(listaDeTiposServico)"
        @sgpTabelaLinhasSelecionadasEmit="gerenciadorDeSelecionados"
        @sgpTabelaEditarSelecionadoEmit="editarSelecionado"
        @sgpTabelaDeletarSelecionadoEmit="deletarSelecionado"
        @sgpTabelaRestaurarSelecionadoEmit="restaurarSelecionado"
        selecionarColunas
      >
      </SGPTabelaAvancadaComponent>
    <SGPAlertaComponent v-else></SGPAlertaComponent>

    <SGPModalComponent
      v-if="abrirModal"
      tamanho="lg"
      titulo="Tipos de Serviços"
      @sgpModalFechar="fecharModal"
      :mostrarFooter="false"
    >
      <FormularioCtrlTipoServicoComponent
        :tipoFormulario="tipoFormulario"
        :ctrlTipoServico="ctrlTipoServico"
        @fechar="fecharModal"
        @atualizarListagemTabela="aplicarFiltros"
      />
    </SGPModalComponent> 
    
    <SGPConfirmacaoDelecaoComponent
      v-if="deletarDados"
      @sgpCancelarDelecaoEmit="cancelarDelecao()"
      @sgpConfirmarDelecaoEmit="confirmarDelecao()"
    />
    
    <SGPLoadingComponent v-if="loadingTiposServico"/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import FormularioCtrlTipoServicoComponent from '../components/FormularioCtrlTipoServicoComponent.vue'

export default {
  components: { FormularioCtrlTipoServicoComponent },
  name: 'CtrlTipoServicoPage',

  data () {
    return {
      mostrarSelecionar: true,
      mostrarEditar: true,
      mostrarDeletar: true,
      linhasSelecionadas: [],
      abrirModal: false,
      deletarDados: false,
      tipoFormulario: 'salvar',
      ctrlTipoServico: {},
      opcoesSelect: [
        { 'id': true, 'nome': 'Sim' },
        { 'id': false, 'nome': 'Não' }
      ],
      exibirItensDeletados: ''
    }
  },
  created () {
    this.listarTiposServico();
  },
  computed: {
    ...mapGetters('ctrlTipoServico', ['listaDeTiposServico','loadingTiposServico']),

    colunas () {
      return [
        { key: 'selecionar', label: '', sortable: false },
        { key: 'nome', label: 'Nome', sortable: true },
        { key: 'descricao', label: 'Descrição', sortable: false },
      ]
    }
  },

  methods: {
    ...mapActions('ctrlTipoServico', 
    [
      'listarTiposServico',
      'excluirTipoServico',
      "restaurarTipoServico"
    ]),

    gerenciadorDeSelecionados (selecionados) {
      this.linhasSelecionadas = selecionados;
    },

    editarSelecionado () {
      this.tipoFormulario = 'editar';
      this.ctrlTipoServico = this.linhasSelecionadas[0];
      this.abrirModal = true;
    },

    async restaurarSelecionado(item){
      await this.restaurarTipoServico(item.id);
      await this.listarTiposServico(this.montarPayload());
    },

    deletarSelecionado () {
      this.deletarDados = true;
    },

    cancelarDelecao () {
      this.deletarDados = false;
    },

    async confirmarDelecao () {
      await this.excluirTipoServico(this.linhasSelecionadas);
      this.deletarDados = false;
      await this.listarTiposServico(this.montarPayload());
    },

    adicionarNovo () {
      this.ctrlTipoServico = {};
      this.tipoFormulario = 'salvar';
      this.abrirModal = true;
    },

    fecharModal () {
      this.abrirModal = false;
    },

    filtrarDeletados(event) {
      if(typeof event == 'undefined'){
          return false;
      }

      this.listarTiposServico(this.montarPayload());
    },

    aplicarFiltros() {
      this.listarTiposServico(this.montarPayload());
    },

    montarPayload() {
      return {
          trashed: this.exibirItensDeletados
        }
    }
  }
}
</script>
